var _templateObject = _taggedTemplateLiteralLoose(['\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n  height: 48px;\n'], ['\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n  height: 48px;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: 25%;\n  left: 4px;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: white;\n  border: 1px solid ', ';\n'], ['\n  position: absolute;\n  top: 25%;\n  left: 4px;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: white;\n  border: 1px solid ', ';\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: inline;\n  opacity: 0;\n  z-index: 1;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  margin-right: 10px;\n  cursor: pointer;\n  &:hover ~ ', ' {\n    background: ', ';\n    &::after {\n      content: \'\';\n      display: block;\n      border-radius: 50%;\n      width: 12px;\n      height: 12px;\n      margin: 6px;\n    }\n  }\n  &:checked + ', ' {\n    background: ', ';\n    border: 1px solid ', ';\n    &::after {\n      content: \'\';\n      display: block;\n      border-radius: 50%;\n      width: 10px;\n      height: 10px;\n      margin: 6px;\n      box-shadow: 1px 3px 3px 1px ', ';\n      background: white;\n    }\n  }\n'], ['\n  display: inline;\n  opacity: 0;\n  z-index: 1;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  margin-right: 10px;\n  cursor: pointer;\n  &:hover ~ ', ' {\n    background: ', ';\n    &::after {\n      content: \'\';\n      display: block;\n      border-radius: 50%;\n      width: 12px;\n      height: 12px;\n      margin: 6px;\n    }\n  }\n  &:checked + ', ' {\n    background: ', ';\n    border: 1px solid ', ';\n    &::after {\n      content: \'\';\n      display: block;\n      border-radius: 50%;\n      width: 10px;\n      height: 10px;\n      margin: 6px;\n      box-shadow: 1px 3px 3px 1px ', ';\n      background: white;\n    }\n  }\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  margin-right: 5px;\n  color: ', ';\n'], ['\n  margin-right: 5px;\n  color: ', ';\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Theme from '../../Theme';

var Flex = styled.div(_templateObject);

export var RadioButtonLabel = styled.label(_templateObject2, Theme.colors.darkgrey);

export var RadioButtonInput = styled.input(_templateObject3, RadioButtonLabel, Theme.colors.primaryShadow, RadioButtonLabel, Theme.colors.lightBlue, Theme.colors.lightBlue, Theme.colors.greyOpacity);

export var LabelText = styled.div(_templateObject4, Theme.colors.primary);

var RadioField = function RadioField(_ref) {
  var label = _ref.label,
      value = _ref.value,
      active = _ref.active,
      onChange = _ref.onChange;

  return React.createElement(
    Flex,
    null,
    React.createElement(RadioButtonInput, {
      type: 'radio',
      name: value,
      value: value,
      checked: active === value,
      onChange: onChange
    }),
    React.createElement(RadioButtonLabel, null),
    React.createElement(
      LabelText,
      null,
      label
    )
  );
};

RadioField.propTypes = process.env.NODE_ENV !== "production" ? {
  label: PropTypes.string,
  value: PropTypes.string,
  active: PropTypes.string,
  onChange: PropTypes.func
} : {};

export default RadioField;